module.exports = __webpack_public_path__ + "img/logo-color.4068ed85.png";